import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/ui/button.tsx
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:pointer-events-none disabled:opacity-50 active:scale-[0.97] cursor-pointer",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 active:bg-primary/80 [&.active]:bg-primary/90",
        secondary: "bg-secondary text-secondary-foreground hover:brightness-125 active:brightness-110 [&.active]:bg-secondary/80",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90 active:bg-destructive/80 [&.active]:bg-destructive/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground active:bg-accent/80 [&.active]:bg-accent [&.active]:text-accent-foreground",
        ghost: "hover:bg-accent hover:text-accent-foreground active:bg-accent/80 [&.active]:bg-accent [&.active]:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline active:text-primary/80 [&.active]:underline",
        icon: "hover:bg-accent hover:text-accent-foreground active:bg-accent/80 [&.active]:bg-accent [&.active]:text-accent-foreground"
      },
      // Control ladder, shared with Input/Select so a field and its button
      // always line up: sm 28px · md 32px · lg 36px · xl 44px. Text stays
      // 14px through lg; only xl steps up.
      size: {
        sm: "h-7 px-2.5 text-xs rounded-sm",
        md: "h-8 px-3 text-sm rounded-md",
        lg: "h-9 px-4 text-sm rounded-md",
        xl: "h-11 px-5 text-base rounded-lg",
        icon: "h-8 w-8 rounded-md",
        "icon-sm": "h-7 w-7 rounded-sm",
        "icon-xs": "h-6 w-6 rounded-sm",
        "icon-lg": "h-9 w-9 rounded-md"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "md"
    }
  }
);
var Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx(
      Comp,
      {
        className: cn(buttonVariants({ variant, size, className })),
        ref,
        ...props
      }
    );
  }
);
Button.displayName = "Button";

export {
  buttonVariants,
  Button
};
//# sourceMappingURL=chunk-QXEA2YZ6.js.map